export const DEFAULT_WIDTH = 375;
export const DEFAULT_HEIGHT = 667;
export const MAX_HEIGHT = window.innerHeight;
